<template>
  <section class="container">
    <div class="homepage__section homepage__tools">
      <div class="content" :class="{'active': isActive}">
        <div class="left">
          <h2 v-if="content.h2Titles?.length" :class="{'text-gray': changeColor}">
            {{ content.h2Titles[0] }}
            <span class="text-gradient">
              {{ content.h2Titles[1] }}
            </span>
            {{ content.h2Titles[2] }}
          </h2>
        </div>
        <div v-if="content.h3Titles?.length" class="right">
          <div>
            <CustomizeIcon class="svg-container"/>
            <h3 class="title" :class="{'text-gray': changeColor}">{{ content.h3Titles[0] }}</h3>
            <span>
              {{ t('page-home_customize-content') }}
            </span>
          </div>
          <div>
            <DiagnoseIcon class="svg-container diagnose"/>
            <h3 class="title" :class="{'text-gray': changeColor}">{{ content.h3Titles[1] }}</h3>
            <span>
              {{ t('page-home_diagnose-content') }}
            </span>
          </div>
          <div>
            <ServiceIcon class="svg-container"/>
            <h3 class="title" :class="{'text-gray': changeColor}">{{ content.h3Titles[2] }}</h3>
            <span>
              {{ t('page-home_service-content') }}
            </span>
          </div>
          <div>
            <LiveDataIcon class="svg-container"/>
            <h3 class="title" :class="{'text-gray': changeColor}">{{ content.h3Titles[3] }}</h3>
            <span>
              {{ t('page-home_live-data-content') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useTranslation } from "i18next-vue";
import CustomizeIcon from '../../assets/icons/supportedCars/CustomizeIcon.vue';
import DiagnoseIcon from '../../assets/icons/supportedCars/DiagnoseIcon.vue';
import ServiceIcon from '../../assets/icons/supportedCars/ServiceIcon.vue';
import LiveDataIcon from '../../assets/icons/supportedCars/LiveDataIcon.vue';

const { t } = useTranslation(['page-home']);

const props = defineProps({
  content: {
    type: Object,
    default: {}
  },
  active: Number,
});

const store = useStore();
const parser = new DOMParser();

const content = computed(() => {
  const contentArray = props.content.content?.content;

  if (!Array.isArray(contentArray) || !contentArray.length) {
    return {};
  }

  const text = contentArray[0];

  const doc = parser.parseFromString(text, 'text/html');

  const h2Titles = doc.querySelectorAll('h2');
  const h3Titles = doc.querySelectorAll('h3');

  return {
    h2Titles: [
      h2Titles[0]?.textContent ?? '',
      h2Titles[1]?.textContent ?? '',
      h2Titles[2]?.textContent ?? '',
    ],
    h3Titles: [
      h3Titles[0]?.textContent ?? '',
      h3Titles[1]?.textContent ?? '',
      h3Titles[2]?.textContent ?? '',
      h3Titles[3]?.textContent ?? '',
    ]
  }
})

const isActive = computed(() => props.active >= 2);
const changeColor = computed(() => props.active > 2);

</script>
